<template>
  <ion-footer class="tab-bar-footer">
    <ion-toolbar class="tab-bar-toolbar">
      <div class="tab-bar-container">
        <router-link
          to="/admin/new-orders"
          class="tab-button"
          :class="{ 'active-tab': isActiveTab('/admin/new-orders') }"
        >
          <ion-icon
            :icon="timer"
            class="tab-icon"
            :class="{ 'active-icon': isActiveTab('/admin/new-orders') }"
          />
          <ion-badge
            v-if="preparingOrders > 0"
            color="danger"
            class="notif-badge"
          >
            {{ preparingOrders }}
          </ion-badge>
          <span
            class="tab-label"
            :class="{ 'active-label': isActiveTab('/admin/new-orders') }"
            >New Orders</span
          >
        </router-link>

        <router-link
          to="/admin/confirmed-orders"
          class="tab-button"
          :class="{ 'active-tab': isActiveTab('/admin/confirmed-orders') }"
        >
          <ion-icon
            :icon="checkmark"
            class="tab-icon"
            :class="{ 'active-icon': isActiveTab('/admin/confirmed-orders') }"
          />
          <ion-badge v-if="readyOrders > 0" color="danger" class="notif-badge">
            {{ readyOrders }}
          </ion-badge>
          <span
            class="tab-label"
            :class="{ 'active-label': isActiveTab('/admin/confirmed-orders') }"
            >Confirmed Orders</span
          >
        </router-link>

        <div
          class="tab-button"
          role="button"
          tabindex="0"
          @click="openAccountMenu"
          @keydown="handleAccountKeydown"
        >
          <ion-icon :icon="person" class="tab-icon" />
          <span class="tab-label">Account</span>
        </div>
      </div>
    </ion-toolbar>
  </ion-footer>
</template>

<script>
import { defineComponent } from "vue";
import {
  IonFooter,
  IonToolbar,
  IonIcon,
  IonBadge,
  menuController,
} from "@ionic/vue";
import { timer, checkmark, person } from "ionicons/icons";

export default defineComponent({
  name: "AdminFooter",
  components: {
    IonFooter,
    IonToolbar,
    IonIcon,
    IonBadge,
  },
  props: {
    preparingOrders: {
      type: Number,
      default: 0,
    },
    readyOrders: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      timer,
      checkmark,
      person,
    };
  },
  computed: {
    currentPath() {
      return this.$route?.path || "";
    },
  },
  methods: {
    isActiveTab(path) {
      return this.currentPath === path;
    },
    async openAccountMenu() {
      await menuController.open("end");
    },
    handleAccountKeydown(event) {
      // Handle Enter and Space keys for keyboard accessibility
      if (
        event.key === "Enter" ||
        event.key === " " ||
        event.key === "Spacebar"
      ) {
        // Prevent default for Space to avoid scrolling
        if (event.key === " " || event.key === "Spacebar") {
          event.preventDefault();
        }
        this.openAccountMenu();
      }
    },
  },
});
</script>

<style scoped>
/* Tab Bar Footer */
.tab-bar-footer {
  --background: #ffffff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
}

.tab-bar-toolbar {
  --background: #ffffff;
  --border-width: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  --min-height: 56px;
}

.tab-bar-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 56px;
}

.tab-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  color: #828282;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
  position: relative;
}

.tab-button:hover {
  color: #f87e63;
}

.active-tab {
  color: #f87e63;
  position: relative;
}

.tab-icon {
  font-size: 24px;
  margin-bottom: 4px;
  transition: color 0.2s ease;
}

.active-icon {
  color: #f87e63;
}

.tab-label {
  font-family: "Gilroy", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  transition: color 0.2s ease;
}

.active-label {
  color: #f87e63;
  font-weight: 600;
}

.notif-badge {
  position: absolute;
  top: 2px;
  left: calc(50% + 12px);
  min-width: 18px;
  height: 18px;
  font-size: 11px;
  font-weight: 600;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  --padding-start: 4px;
  --padding-end: 4px;
}
</style>
